/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockDeliverydetailEditCtrl
 */
angular.module('mercury.modules.stock.deliverydetail')
.controller('StockDeliverydetailEditCtrl', ["dialog", "authService", "$http", "ngToast", "$q", "$scope", "StockDeliveryDetails", "title", function(dialog, authService, $http, ngToast, $q, $scope, StockDeliveryDetails, title) {
  title.set('Delivery Address Details');

  $scope.detailsLoading = StockDeliveryDetails.get();
  $scope.detailsLoading.then(
    function(response) {
      $scope.details = response;
    }
  );

  $scope.changePostal = function() {
    if ($scope.details.separatePostalAddress) {
      $scope.details.postal1 = angular.copy($scope.details.delivery1);
      $scope.details.postal2 = angular.copy($scope.details.delivery2);
      $scope.details.postal3 = angular.copy($scope.details.delivery3);
      $scope.details.postal4 = angular.copy($scope.details.delivery4);
    } else {
      $scope.details.postal1 = null;
      $scope.details.postal2 = null;
      $scope.details.postal3 = null;
      $scope.details.postal4 = null;
    }
  };

  $scope.saveDetails = function() {
    $scope.detailsSaving = StockDeliveryDetails.save($scope.details);
    $scope.detailsSaving.then(function() {
      ngToast.success('Delivery details saved');
    });
  };

  $scope.uploadStarted = function() {
    $scope.imageUploading = $q.defer();
  };

  $scope.fileUploaded = function(message) {
    var result = JSON.parse(message);
    $scope.details.logo = result.id;

    $scope.imageUploading.resolve();

    StockDeliveryDetails.getLogo(result.id)
    .then(function(response) {
      $scope.details.logosrc = response;
    });
  };

  $scope.uploadFailed = function(message) {
    $scope.imageUploading.reject();

    var result = JSON.parse(message);
    dialog.alert(result.message);
  };
}]);
